import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { ComplaintTypeEntity } from '../entities/complaintType.entity';
import { State } from '../State';
import { getComplaintTypes } from '../State/selectors/complaintType.selectors';
import { ComplaintTypeActionTypes } from '../State/actions/complaintType.actions';

@Injectable({
  providedIn: 'root'
})
export class ComplaintTypeResolver implements Resolve<ComplaintTypeEntity[]> {
  constructor(private store: Store<State>) {
  }

  resolve() {
    const value$ = this.store.select(getComplaintTypes);

    value$
      .pipe(
        filter(value => !value),
        take(1),
        tap(() => {
          if (localStorage.getItem('token') != null) {
            this.store.dispatch(ComplaintTypeActionTypes.GetComplaintTypeRequest());
          }
        })
      )
      .subscribe();

    return value$.pipe(
      filter(value => !!value),
      take(1)
    );
  }
}
